import { render, staticRenderFns } from "./cell-ledger-reason.vue?vue&type=template&id=33e67811&scoped=true"
import script from "./cell-ledger-reason.ts?vue&type=script&lang=ts&external"
export * from "./cell-ledger-reason.ts?vue&type=script&lang=ts&external"
import style0 from "./cell-ledger-reason.vue?vue&type=style&index=0&id=33e67811&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../web-ai-translation/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33e67811",
  null
  
)

export default component.exports